const map = {
  1: {
    KLEROS_LIQUID: "0x988b3a538b618c7a603e1c11ab82cd16dbe28069",
    BINARY_ARBITRABLE_PROXY: "0xc7e49251807780dFBbCA72778890B80bd946590B",
    POLICY_REGISTRY: "0x03a9458d77dd705829fa758c64dbe770385295cc"
  },
  42: {
    KLEROS_LIQUID: "0x60b2abfdfad9c0873242f59f2a8c32a3cc682f80",
    BINARY_ARBITRABLE_PROXY: "0xB00A5117C1A7fAf81804392F3ed7e447b23e731b",
    POLICY_REGISTRY: "0xFC53D1d6dDc2C6Cdd403cb7DBf0f26140D82e12d"
  }
};

export default map;
